import React, { ChangeEvent, useCallback } from 'react';
import { useFormikContext, getIn } from 'formik';
import styled from 'styled-components';
import { UdsFC } from '../../../types';
import { Checkbox, CheckboxProps } from '../../Checkbox/Checkbox';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormCheckbox: UdsFC<CheckboxProps> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const disabled = 'disabled' in props ? props.disabled : context.disabled;
  const value = 'checked' in props ? props.checked : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (e: ChangeEvent<Element>) => {
      if (onChange) {
        onChange(e);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, !value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue, value]
  );
  return (
    <StyledCheckbox
      {...props}
      disabled={disabled}
      checked={value}
      onChange={handleOnChange}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
      muiCheckboxProps={{
        id: (props.id ?? context.name) ? `${context.name}-input` : undefined
      }}
    />
  );
};

const StyledCheckbox = styled(Checkbox)`
    margin-top: 22px;
`;
